<template>
  <RegisterFrom />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import RegisterFrom from "../components/Register/RegisterFrom.vue";

export default defineComponent({
  name: "RegisterPage",
  components: {
    RegisterFrom,
  },
});
</script>